// src/middleware/page-type.ts
export function getPageType(path: string): string {
  const array = path.split('/')
  const firstPath = array[1] || array[2] || ''

  const pageTypes: Record<string, string> = {
    collection: 'Category',
    collections: 'Category',
    cm24: 'Category',
    '84rising': 'Category',
    product: 'Product',
    cart: 'Basket',
    spotlight: 'Search',
    checkout: 'Confirmation',
    error: 'Checkout',
    '': 'Home',
    page: 'Content',
    lp: 'Content',
  }

  return pageTypes[firstPath] || 'Content'
}
